/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetActiveLanguagesQueryResponse,
  GetActiveLanguagesPathParams,
} from "../types/GetActiveLanguages.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getActiveLanguagesQueryKey = (
  productSheetGroupId:
    | GetActiveLanguagesPathParams["productSheetGroupId"]
    | undefined
) =>
  [
    {
      url: "/v1/organization-settings/get-active-languages/:productSheetGroupId",
      params: { productSheetGroupId: productSheetGroupId },
    },
  ] as const

export type GetActiveLanguagesQueryKey = ReturnType<
  typeof getActiveLanguagesQueryKey
>

/**
 * @summary Get active languages by productSheetGroup
 * {@link /v1/organization-settings/get-active-languages/:productSheetGroupId}
 */
export async function getActiveLanguages(
  productSheetGroupId: GetActiveLanguagesPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetActiveLanguagesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-active-languages/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getActiveLanguagesQueryOptions(
  productSheetGroupId:
    | GetActiveLanguagesPathParams["productSheetGroupId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getActiveLanguagesQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetActiveLanguagesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetActiveLanguagesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getActiveLanguages(productSheetGroupId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get active languages by productSheetGroup
 * {@link /v1/organization-settings/get-active-languages/:productSheetGroupId}
 */
export function useGetActiveLanguages<
  TData = ResponseConfig<GetActiveLanguagesQueryResponse>,
  TQueryData = ResponseConfig<GetActiveLanguagesQueryResponse>,
  TQueryKey extends QueryKey = GetActiveLanguagesQueryKey,
>(
  productSheetGroupId:
    | GetActiveLanguagesPathParams["productSheetGroupId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetActiveLanguagesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getActiveLanguagesQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getActiveLanguagesQueryOptions(productSheetGroupId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
